import {addUTMParametersToDict} from '../utils/url';
import { onPath } from '../utils/path';

onPath('/meet/*', () => {
  // expose this globally, so we can use it in our meeting link
  // TODO: move logic out of the single page
  window.addUTMParametersToDict = addUTMParametersToDict;
});